import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { concat, from, Observable } from 'rxjs';
import { AzureMonitoringService } from '../services/AzureMonitoringService';
import { util } from '../util/util';
import { NotificationService } from 'app/core/services/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { switchMap } from 'rxjs/operators';

const ADAL_401_ERROR_MESSAGE = "This user can't log in or is not activated.  Please contact your administrator.";

export abstract class AbstractEffects {
  protected constructor(protected translateService: TranslateService, protected azureMonitoringService: AzureMonitoringService, protected notificationService: NotificationService) {}

  protected handleFail(errorResponse: HttpErrorResponse, titleKey: string, observables: Observable<Action>[]): Observable<Action> {
    return from(util.getErrorMessage(errorResponse)).pipe(
      switchMap(errorMessage => {
        let disableClose = false; // (err.status === 401); had to disable it because for get contract details, we got a 401:
        // Customer 'RE.2000016' belonging to Sales Organisation 'NL10' is not available for user 'a71da0d2-883e-46a3-8871-923d55896381'.

        // if (errorResponse.stack) {
        //   logger.error(errorResponse.stack);
        // }

        if (errorResponse?.status == 406) {
          disableClose = true;
          errorMessage = {
            message: this.translateService.instant('ERRORS.AUTHORIZATION.ANOTHER_SESSION_WITH_DIFFERENT_CUSTOMER_OPENED'),
            subMessages: [],
            errorResponse,
          };
        }

        let errorType: 'success' | 'error' | 'warning' | 'info' = 'error';
        if (errorResponse.status === 401) {
          errorType = 'warning';
        } else if (errorResponse.error?.Level) {
          errorType = errorResponse.error.Level.toLowerCase();
        } else if (errorMessage?.errorResponse?.error?.level) {
          errorType = errorMessage.errorResponse.error.level.toLowerCase();
        }

        this.azureMonitoringService.logException(errorMessage.errorResponse.error);
        this.notificationService.showModal({
          disableClose,
          type: errorType,
          message: errorMessage.message,
          showLogout: errorResponse.status === 401,
          subMessages: errorMessage.subMessages,
          messageCode: errorResponse.error?.messageCode,
          translationParams: errorResponse.error?.translationParams,
          verbose: errorMessage.errorResponse.error,
          title: this.translateService.instant(titleKey),
        });
        return concat(...observables);
      })
    );
  }
}
